import { URLState } from '../../../models';
import { URL_MUTATIONS_KEYS } from '../url.const';
import { URLMutation } from '../url.interfaces';

export class SetStateFromUrlMutation implements URLMutation {
  mutations = {
    [URL_MUTATIONS_KEYS.setStateFromURL]: (urlState: URLState, newStateFromUrl: boolean) => {
      urlState.stateFromUrl = newStateFromUrl;
    }
  };
}
